/* lua.js generated code 0.3.0 */

require("clover/data/DataRef")
require("clover/data/HttpCache")
var debugUserData = false
var instance = null
UserManager = xClass("UserManager")
require("clover/data/ConvertRewardManager")

kMaxLevels = 135

UserManager.hasInstance = function() {
    return instance != null;
}
UserManager.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserManager.new()
    }
    return instance
}
UserManager.prototype.ctor = function () {
    var self = this
    self.httpCache = HttpCache.new()
    self.reset()
}
UserManager.prototype.reset = function () {
    var self = this
    self.appName = ""
    self.branchs = table()
    self.createTime = 28800000
    self.dailyData = DailyDataRef.new()
    self.friendIds = table()
    self.inviteCode = null
    self.lostType = 0
    self.openId = null
    self.platform = kDefaultSocialPlatform
    self.profile = ProfileRef.new()
    self.props = table()
    self.lotteryLeft = 0
    self.scores = table()
    self.sessionKey = null
    self.setting = 0
    self.timeProps = table()
    self.uid = null
    self.unlockInfo = UnlockInfoRef.create()
    self.updateInfo = UpdateInfoRef.new()
    self.updateRewards = null   // 更新奖励 已废弃
    self.user = UserRef.new()
    self.userShow = UserShowRef.new()
    self.userExtend = UserExtendRef.new()
    self.userReward = UserRewardRef.new()
    self.userType = 0
    self.mark = MarkRef.create()
    self.dailySendInfo = DailySendGiftRef.create()
    self.fetchedStarRewardIds = table()
    self.fetchedCids = table()
    self.introCheckLevelId = 0
    self.locationUpdateTime = 0
    self.msgAmount = MsgAmountRef.create()
    self.checkedSystemMessages = table()
    self.localDailyData = LocalDailyDataRef.create()
    self.continueLoginDays = null
    self.canFetchBetaReward = false
    self.httpCache.clearCachedHttp()
    self.dataTemp = table([1, "isNewUser", false], [1, "loginTime", 0])
    self.beLiked = 0
    self.headFrameId = 0
    self.areaCode = null
    self.groupInfos = table()
    self.appConfigRef = AppConfigRef.create()
    self.honor = 0
    self.honorUpdateTime = 0
    //self.appPromInfo = AppPromInfoRef.create()
    self.energyShare = false
    self.userTagData = table()
    self.settings = SettinsRef.create()
    self.systemConfig = {}
    self.inNewLevelEnd = false;
    self.lastLoginSec = 0;
    self.lastLvlReplay = null;
    self.canFetchBackReward = 0; // 回归奖励状态，0-未展示，1-展示但未领取，2-已领取
    self.userLabel = null; // 掉落优化用标签
    self.isOpenNewLevel = false// 是否需要提示开启新的关卡
    self.wxGifts = table(); // 微信后台配置游戏圈礼包功能
    self.needRequestSubscribeSystemMessage = false; // 是否需要在关末请求微信更新提醒消息

    self.skipGameAimAnim = true // 是否跳过关卡的目标面板动画
    self.ttSmallAmountUseDiamond = false // 抖音小额支付直购
    self.ttRevivistReward = false

    self.canUseGMCmd = false    // 是否可以使用命令
    self.canGmPropUse = false        // 是否可以无限使用道具
    self.skipLevelPopout = false; //是否跳过关前的自动弹出 EnterLevelPopoutAction
    self.starDrawRaffled = false;//星星幸运礼是否抽过奖
    self.starDrawGuide = true;//星星幸运礼是否引导过
    self.pvpGuide = true;//星星幸运礼是否引导过
}
function encodeListDataRef(list) {
    var dst = table()
    for (var i = 1, v = list[1]; v; i++, v = list[i]) {
        dst[i] = v.encode()
    }
    return dst
}

UserManager.verifyUserData = function (src) {
    if(type(src) !== "table"){
        return false
    }
    if(type(src.user) !== "table"){
        return false
    }
    if(type(src.profile) !== "table"){
        return false
    }
    if(type(src.userExtend) !== "table"){
        return false
    }
    return true
}

UserManager.prototype.encode = function () {
    var self = this
    var dst = table()
    dst.appName = self.appName
    dst.branchs = encodeListDataRef(self.branchs)
    dst.createTime = self.createTime
    dst.dailyData = self.dailyData.encode()
    dst.lastCheckTime = self.lastCheckTime
    dst.friendIds = self.friendIds
    dst.inviteCode = self.inviteCode
    dst.openId = self.openId
    dst.platform = self.platform
    dst.profile = self.profile.encode()
    dst.props = encodeListDataRef(self.props)
    dst.scores = encodeListDataRef(self.scores)
    dst.setting = self.setting
    dst.timeProps = encodeListDataRef(self.timeProps)
    dst.uid = self.uid
    dst.unlockInfo = self.unlockInfo.encode()
    dst.user = self.user.encode()
    dst.userExtend = self.userExtend.encode()
    dst.userReward = self.userReward.encode()
    dst.userType = self.userType
    dst.mark = self.mark.encode()
    dst.dailySendInfo = self.dailySendInfo.encode()
    dst.fetchedStarRewardIds = self.fetchedStarRewardIds
    dst.fetchedCids = self.fetchedCids
    dst.introCheckLevelId = self.introCheckLevelId
    dst.locationUpdateTime = self.locationUpdateTime
    dst.checkedSystemMessages = self.checkedSystemMessages
    dst.msgAmount = self.msgAmount.encode()
    dst.localDailyData = self.localDailyData.encode()
    dst.continueLoginDays = self.continueLoginDays
    dst.httpCache = self.httpCache.encode()
    dst.ingameLimit = self.ingameLimit
    dst.beLiked = self.beLiked
    dst.groupInfos = encodeListDataRef(self.groupInfos)
    dst.headFrameId = self.headFrameId
    return dst
}
UserManager.prototype.checkDateChange = function () {
    var self = this
    var currentTime = Math.ceil(Localhost.time() / 1000)
    var currentDate = os.date("*t", currentTime)
    if (!self.lastCheckTime) { // not initialized 
        cc.log("not initialized ")
        self.lastCheckTime = currentTime
        Localhost.flushCurrentUserData()
    }
    var lastTime = self.lastCheckTime || currentTime
    var lastDate = os.date("*t", lastTime)
    var compareResult = compareDate(lastDate, currentDate)
    if (compareResult === -1) {
        self.lastCheckTime = currentTime
        UserManager.getInstance().getDailyData().resetAll()
        UserManager.getInstance().getLocalDailyData().resetAll()
        Localhost.flushCurrentUserData()
    }
}
UserManager.prototype.getDailyData = function () {
    var self = this
    self.checkDateChange()
    return self.dailyData
}
UserManager.prototype.getLocalDailyData = function () {
    var self = this
    self.localDailyData.checkDateChange()
    return self.localDailyData
}
UserManager.prototype.isPlayerRegistered = function () {
    var self = this
    return self.uid && self.uid !== self.sessionKey
}
UserManager.prototype.getMaxLevelInOpenedRegion = function () {
    var self = this
    var curLevelId = UserManager.getInstance().user.topLevelId
    var nextLevelAreaRef = MetaManager.getInstance().getNextLevelAreaRefByLevelId(curLevelId)
    var areaMaxLevel = 0
    if (nextLevelAreaRef) {
        areaMaxLevel = tonumber(nextLevelAreaRef.minLevel) - 1
    } else {
        for (var k in MetaManager.getInstance().level_area) {
            var v = MetaManager.getInstance().level_area[k]
            if (tonumber(v.maxLevel) === 9999) {
                areaMaxLevel = tonumber(v.minLevel) - 1
                break
            }
        }
    }
    return areaMaxLevel
}
UserManager.prototype.getFullStarInOpenedRegion = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    var areaMaxLevel = self.getMaxLevelInOpenedRegion()
    var fullStar = areaMaxLevel * 3
    return fullStar
}
function debugMessage(msg) {
    if (debugUserData) {
        cc.log("[UserManager]", "" + msg)
    }
}
UserManager.prototype.decode = function (src) {
    var self = this
    self.initFromLua(src)
}
UserManager.prototype.createNewUser = function () {
    var self = this
    var globalMeta = MetaManager.getInstance().global
    var userCoin = globalMeta.user_init_coin || 30000
    self.createTime = Localhost.time()
    self.platform = kDefaultSocialPlatform
    self.profile.headUrl = 0
    self.user.uid = self.uid || 0
    self.user.setEnergy(globalMeta.user_energy_init_count || 30)
    //self.user.setEnergy(30)
    self.user.setCoin(userCoin)
    self.user.setUpdateTime(os.time() * 1000)
    self.user.setTopLevelId(1)
    self.createTime = os.time() * 1000
    self.aiTestGroup = null;
    self.levelHighTryTimes = null;
    self.location = null;
}
UserManager.prototype.syncUserFromLua = function (src) {
    var self = this
    if (src) {
        self.user.fromLua(src)
    }
}

UserManager.prototype.getCleanData = function (){
    let data = UserManager.getInstance().encode()
    // data.httpCache = null
    delete data.httpCache
    return $tableToObj(data)
}

UserManager.prototype.getCleanData2 = function(){
    var self = this
    let appName = self.appName
    let createTime = self.createTime
    let inviteCode = self.inviteCode
    let lastCheckTime = self.lastCheckTime
    let exchangeCode = self.exchangeCode
    let headFrameId = self.headFrameId
    let timeProp = self.mergeTimeProps(self.timeProps)
    let unlockInfo = self.unlockInfo
    let userType = self.userType
    let setting = self.setting
    let dailySendInfo = self.dailySendInfo
    let ingameLimit = self.ingameLimit
    let beLiked = self.beLiked
    let groupInfos = clone(self.groupInfos)

    let friendIds = []
    if(self.friendIds.__isLuaTable){
        for(let item in self.friendIds){
            friendIds[item] = self.friendIds[item]
        }
    }
    let user = clone(self.user)
    let profile = clone(self.profile)
    let userExtend = clone(self.userExtend)
    let props = clone(self.props)
    let scores = clone(self.scores)
    let branchs = clone(self.branchs)
    let mark = close(self.mark)

    return {
        createTime : createTime,
        appName    : appName,
        inviteCode : inviteCode,
        lastCheckTime : lastCheckTime,
        exchangeCode : exchangeCode,
        headFrameId : headFrameId,
        timeProp : timeProp,
        unlockInfo : unlockInfo,
        userType : userType,
        setting : setting,
        dailySendInfo : dailySendInfo,
        ingameLimit : ingameLimit,
        beLiked : beLiked,
        groupInfos : groupInfos,
        friendIds : friendIds,
        user : user,
        profile : profile,
        userExtend : userExtend,
        props : props,
        scores : scores,
        branchs : branchs,
        mark : mark
    }
}
UserManager.prototype.initFromLua = function (src) {
    var self = this
    self.appName = src.appName
    self.promotionShow = src.promotionShow
    self.friendIds = src.friendIds || table()
    if (MetaManager.getInstance().level_area) {
        for (var k in MetaManager.getInstance().level_area) {
            var v = MetaManager.getInstance().level_area[k]
            if (v.maxLevel === 9999) {
                kMaxLevels = v.minLevel - 1
                break
            }
        }
    }
    FriendManager.getInstance().reset()
    if(src.friendIds){
        for (var i = 1, v = src.friendIds[1]; v; i++, v = src.friendIds[i]) {
            if(v == null){
                continue
            }
            src.friendIds[i] = v = tonumber(v)
            FriendManager.getInstance().setAsFriendRef(UserRef.create().fromLua(table([1, "uid", v],[1, "topLevelId", 1])), ProfileRef.create().fromLua(table([1, "uid", v])))
        }
    }
    self.createTime = src.createTime
    self.inviteCode = src.inviteCode || ""
    cc.log("inviteCode " + tostring(src.inviteCode))
    debugMessage("FriendIds")
    if (debugUserData) {
        for (var i = 1, v = self.friendIds[1]; v; i++, v = self.friendIds[i]) {
            cc.log("FriendId:", v)
        }
    }
    debugMessage(self.appName)
    debugMessage("UserRef")
    self.user = UserRef.new()
    self.user.fromLua(src.user)
    self.uid = self.user.uid
    self.profile = ProfileRef.new()
    self.profile.fromLua(src.profile)
    debugMessage("UserExtendRef")
    self.userExtend = UserExtendRef.new()
    self.userExtend.fromLua(src.userExtend)
    self.userShow = UserShowRef.new()
    self.userShow.fromLua(src.userShow)
    debugMessage("DailyDataRef")
    self.dailyData = DailyDataRef.new()
    self.dailyData.fromLua(src.dailyData)
    self.lastCheckTime = src.lastCheckTime
    self.exchangeCode = src.exchangeCode
    self.headFrameId = src.headFrameId
    debugMessage("PropRef")
    self.props = table()
    if (src.props) {
        for (var i in src.props) {
            var v = src.props[i]
            if(v == null){
                continue
            }
            var p = PropRefEncypt.new()
            p.fromLua(v)
            self.props[i] = p
        }
    }
    // 限时道具
    cc.log("[AddStar] self.timeProps",src.timeProps)
    self.mergeTimeProps(src.timeProps)
    debugMessage("ScoreRef")
    self.scores = table()
    let topLevelId = self.getUserRef().getTopLevelId()
    if (type(src.scores) === "table") {
        // 后端返回的数据在 1号位置多一个
        if (src.scores[1] == null) {
            src.scores.splice(1,1)
        }
        // for (let i = 100; i <= topLevelId; i++) {
        //     var v = src.scores[i]
        //     if(v == null){
        //         continue
        //     }
        //     var p = ScoreRef.new()
        //     p.fromLua(v)
        //     if(!p){
        //         continue
        //     }
        //     self.scores[tonumber(i)] = p
        // }
        for (let i = topLevelId,j = 1; j <= $len(src.scores); i--,j++) {
            let v = src.scores[j]
            if(v == null){
                continue
            }
            let p = ScoreRef.new()
            p.fromLua(v)
            if(!p){
                continue
            }
            self.scores[tonumber(p.levelId)] = p
        }
        // self.scores[tonumber(topLevelId)] = src.scores[i]

        // for (var i in src.scores) {
        //     var v = src.scores[i]
        //     if(v == null){
        //         continue
        //     }
        //     var p = ScoreRef.new()
        //     p.fromLua(v)
        //     if(!p){
        //         continue
        //     }
        //     self.scores[tonumber(i)] = p
        // }
        // 不需要写入local storage
        // Localhost.getInstance().syncLevelScores(src.scores, false)
    }
    cc.log("[scores]", self.scores)
    function lastLevelDataErrorLog(reason) {
        let uid = UserManager.getInstance().uid
        LogToLogCenter(new Error(`parse last level data error at logintime, uid: ${uid}, lastRecord: ${JSON.stringify(last_score_info)}, reason: ${reason}`))
    }
    // 合并本地关卡数据
    let last_score_info = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_PASS_LEVEL_INFO)
    if(last_score_info && last_score_info !== ""){
        try {
            last_score_info = JSON.parse(last_score_info)
        } catch (error) {
            lastLevelDataErrorLog(error)
            cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
            last_score_info = null            
        }
        if(last_score_info && last_score_info.levelId && last_score_info.star && last_score_info.score && last_score_info.replay){
            if (!self.scores[last_score_info.levelId] && self.scores[last_score_info.levelId - 1]) {
                var p = ScoreRef.new()
                p.fromLua(last_score_info)
                if(p){
                    self.scores[last_score_info.levelId] = p
                    self.user.setTopLevelId(last_score_info.levelId + 1)
                }
            }else if (LevelType.isBuildShipLevel(last_score_info.levelId)){

            }else {
                // 清除无用的 score 数据
                lastLevelDataErrorLog("无用的 score 数据")
                cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
            }
        }else {
            lastLevelDataErrorLog(`无效的 score 数据, last_score_info: ${!!last_score_info}, table: ${type(last_score_info) === "table"}, levelId, star, score, replay: [${last_score_info.levelId > 0}, ${last_score_info.star > 0}, ${last_score_info.score > 0}, ${!!last_score_info.replay}]`)
            cc.UserDefault.getInstance().removeKey(LOCAL_LAST_PASS_LEVEL_INFO)
        }
    }
    //分支关卡数据
    self.branchs = table()
    if (src.branchs) {
        for (var i in src.branchs) {
            var v = src.branchs[i]
            if(v == null){
                continue
            }
            var p = BranchRef.new()
            p.fromLua(v)
            self.branchs[i] = p
        }
    }
    if (src.checkedSystemMessages && type(src.checkedSystemMessages) === "table") {
        for (var _ in src.checkedSystemMessages) {
            var v = src.checkedSystemMessages[_]
            if(v == null){
                continue
            }
            table.insert(self.checkedSystemMessages, v)
        }
    }
    self.fetchedStarRewardIds = table()
    if (src.fetchedStarRewardIds && type(src.fetchedStarRewardIds) === "table") {
        for (var k in src.fetchedStarRewardIds) {
            var v = src.fetchedStarRewardIds[k]
            if(v == null){
                continue
            }
            table.insert(self.fetchedStarRewardIds, v)
        }
    }
    self.fetchedCids = table()
    if (src.fetchedCids && type(src.fetchedCids) === "table") {
        for (var k in src.fetchedCids) {
            var v = src.fetchedCids[k]
            if(v == null){
                continue
            }
            table.insert(self.fetchedCids, v)
        }
    }
    if (src.localDailyData) {
        self.localDailyData.fromLua(src.localDailyData || table())
    }
    self.msgAmount = MsgAmountRef.create()
    self.msgAmount.fromLua(src.msgAmount)
    self.lotteryLeft = src.lotteryLeft || 0
    if (src.introCheckLevelId) {
        self.introCheckLevelId = src.introCheckLevelId
    }
    if (src.locationUpdateTime) {
        self.locationUpdateTime = src.locationUpdateTime
    }
    //已同意请求的 关卡好友信息
    debugMessage("UnLockFriendInfoRef")
    self.unlockInfo.fromLua(src.unlockInfo || table())
    // 更新信息
    cc.log(table.tostring(src.updateInfo))
    self.updateInfo = UpdateInfoRef.create().fromLua(src.updateInfo || table())
    self.updateRewards = src.updateRewards
    self.compenList = src.compenList
    self.actInfos = src.actInfos
    self.userReward = UserRewardRef.create().fromLua(src.userReward || table())
    self.userType = src.userType || 0
    self.setting = src.setting || 0
    self.lostType = src.lostType || 0
    self.createTime = src.createTime || 28800000
    if (src.markVersion) {
        self.mark = MarkRef.create().fromLua(src.markNew, src.markVersion)
    } else {
        self.mark = MarkRef.create().fromLua(src.mark, src.markVersion)
    }
    self.continueLoginDays = src.continueLoginDays || 0
    self.canFetchBetaReward = src.canFetchBetaReward
    self.dailySendInfo = self.dailySendInfo.fromLua(src.dailySendInfo || table())
    self.ingameLimit = src.ingameLimit
    self.beLiked = src.beLiked || 0
    self.settings = self.settings.fromLua(src.settings || {})
    // require("activity/BattlePass/BattlePassLogic").getInstance().setTimeConfig()
    self.groupInfos = table()
    if (src.groupInfos) {
        for (var i in src.groupInfos) {
            var v = src.groupInfos[i]
            if(v == null){
                continue
            }
            var p = GroupInfoRef.new()
            p.fromLua(v)
            self.groupInfos[i] = p
        }
    }
    // self.user.energy = 0
    self.systemConfig = src.systemConfig || {}
    //  检查是否需要转换海岛名称（多语言原因）
    for (let i = 1; i < self.systemConfig.islands.length; i++) {
        let islandInfo = self.systemConfig.islands[i];
        if (islandInfo && islandInfo.name && islandInfo.name.indexOf("island.name.") > -1) {
            islandInfo.name = getText(islandInfo.name);
        }
    }
    // sort island
    let islandList = self.systemConfig.islands;
    if (islandList != null) {
        self.systemConfig.islands = islandList.sort((a, b)=>{
            return (a == null? -1: a.id) - (b == null? -1: b.id)
        });
    }
    self.islandsInfo = src.islandsInfo
    require("clover/scene/component/IslandsSystem/IslandsManager").getInstance().dataFromLogin(src.islandsInfo)
    self.starChestInfo = src.starChestInfo || {starCount: 10, type: ChestType.normal, rewards: table(
        {itemId: 14, num: 20},
        {itemId: 10005, num: 4}
    )}
    self.iconMap = src.iconMap || {}
    self.initActMissionHelper()

    self.aiTestGroup = src.aiTestGroup; 
    self.levelHighTryTimes = src.levelHighTryTimes;
    self.topLevelPlayNum = src.topLevelPlayNum || 0
    cc.log("[location] topLevelPlayNum",self.topLevelPlayNum)
    // self.location = src.location;
    self.updateLocation(src.location)
    cc.log("[location] self.location",self.location)
    self.coastStarDailyReward = src.coastStarDailyReward;
    self.coastStarTotalReward = src.coastStarTotalReward;
    self.groupTestInfo = src.groupTestInfo || {}; 
    cc.log("[AddStar] self.groupTestInfo",self.groupTestInfo)
    self.canFetchFillStarReward = src.canFetchFillStarReward; 
    // self.canFetchFillStarReward = true
    cc.log("[AddStar] self.canFetchFillStarReward",self.canFetchFillStarReward)
    self.iosPay = src.iosPay
    cc.log("iosPayService src",src.iosPayService)
    self.iosPayService = src.iosPayService
    self.adLabelInfo = src.adLabelInfo
    cc.log("lightningRush src",src.rushLimit)
    self.rushLimit = src.rushLimit
    cc.log("mystery src",src.mysteriousIsland)
    self.mysteriousIsland = src.mysteriousIsland
    cc.log("purpleAmyMagic src",src.purpleAmyMagic)
    self.purpleAmyMagic = src.purpleAmyMagic
    cc.log("iosPayServiceUse src",src.iosPayServiceUse)
    self.iosPayServiceUse = src.iosPayServiceUse
    cc.log("abTestInfo src",src.abTestInfo)
    self.abTestInfo = src.abTestInfo || {}
    self.skipGameAimAnim = true
    cc.log("[Novice] canFetchBeginnerGift="+src.canFetchBeginnerGift)
    self.canFetchBeginnerGift = src.canFetchBeginnerGift || false
    cc.log("monthCardInfo src",src.monthCardInfo)//月票
    self.monthCardInfo = src.monthCardInfo || {}
    self.islandTreasureInfo = src.islandTreasureInfo || {}
    self.updateAdSkipExpireTs( src.settings.adSkipExpireTs || 0)
    //过滤活动info请求使用
    self.loginLevelId = self.user.topLevelId;
    let ttSmallAmountUseDiamond = src.userExtend.gameClientSetting.ttSmallAmountUseDiamondV2 || {value:false}
    self.ttSmallAmountUseDiamond = ttSmallAmountUseDiamond.value
    console.log("[tt] ttSmallAmountUseDiamond="+self.ttSmallAmountUseDiamond)
    self.ttRevivistReward = (cc.UserDefault.getInstance().getIntegerForKey("tt_revisit_reward", 0) == 1)
    self.inReview = src.inReview
    cc.log("inReview src",src.inReview)
}
UserManager.prototype.getPurpleAmyMagic= function () {
    return this.purpleAmyMagic
}
UserManager.prototype.getMysteriousIsland= function () {
    return this.mysteriousIsland || {}
}
UserManager.prototype.getAdLabelInfo = function () {
    return this.adLabelInfo || {}
}
UserManager.prototype.groupTestInfoByKey = function (key) {
    // adPreProp
    return this.groupTestInfo[key]
}
UserManager.prototype.updateFetchFillStarReward = function () {
    this.canFetchFillStarReward = false
}
// 更新定位细腻
UserManager.prototype.updateLocation = function (data) {
    if (!data){
        // return
        data = {
            city: "其他",
            country: "0",
            ip: "",
            locationList: ["0"],
            nextChooseTime: 0,
            province: "0"
        }
    }
    let self = this
    self.location = {}
    for (const key in data) {
        if (key != "locationList"){
            if (key == "city" || key == "country" || key == "province"){
                self.location[key] = decodeURI(data[key]);
            }else{
                self.location[key] = data[key];
            }
        }
    }
    self.location.locationList = []
    let locationList = data.locationList || []
    self.location.locationList.push(decodeURI(self.location.province)) 

    for (let i = 0; i < locationList.length; i++) {
        let conf = locationList[i]
        if (conf && conf != self.location.province && decodeURI(conf) != self.location.province){
            self.location.locationList.push(decodeURI(conf)) 
        }
        
    }
}

// 海滨之星
UserManager.prototype.getSeasideRankDailyRewards = function () {
    if (!this.coastStarDailyReward) return false
    let arr = []
    for (let i = 1; i < this.coastStarDailyReward.length; i++) {
        mergeDataToArr(arr,this.coastStarDailyReward[i],"itemId","num")
    }
    return arr
}
UserManager.prototype.clearSeasideRankDailyRewards = function () {
    this.coastStarDailyReward = null
}

UserManager.prototype.getSeasideRankTotalRewards = function () {
    if (!this.coastStarTotalReward) return false
    let arr = []
    for (let i = 1; i < this.coastStarTotalReward.length; i++) {
        // arr.push(this.coastStarTotalReward[i])
        mergeDataToArr(arr,this.coastStarTotalReward[i],"itemId","num")
    }
    return arr
}

UserManager.prototype.clearSeasideRankTotalRewards = function () {
    this.coastStarTotalReward = null
}
// 海滨之星

UserManager.prototype.getHeadFrameId = function () {
    var self = this
    return self.headFrameId || 0
}
UserManager.prototype.get3StarLevelCount = function (startLevel, endLevel) {
    var self = this
    var result = 0
    var $var66 = startLevel,$limit67 = endLevel
    for (var i = $var66; i <= $limit67; i += 1) {
        var scoreRef = self.getUserScore(i)
        if (scoreRef && scoreRef.star >= 3) {
            result = result + 1
        }
    }
    return result
}
UserManager.prototype.get3StarMaxSerialLevel = function () {
    var self = this
    var passedTopLevel = self.getPassedTopLevel()
    var max3StarLevel = 0
    var $limit74 = passedTopLevel
    for (var i = 1; i <= $limit74; i += 1) {
        var scoreRef = self.getUserScore(i)
        if (scoreRef == null || scoreRef.star < 3) {
            break
        } else {
            max3StarLevel = i
        }
    }
    return max3StarLevel
}
UserManager.prototype.checkLevelFrame = function () {
    var self = this
    // WARN: maybe multi result
    return MetaManager.headFrameMeta_getFrameIdByMainLevel(self.get3StarMaxSerialLevel())
}
UserManager.prototype.loadUser = function (uid, sessionKey) {
    var self = this
    self.uid = uid
    self.sessionKey = sessionKey
    var userData = Localhost.readUserDataByUserID(uid)
    if (userData) {
        self.initFromLua(userData.user)
        self.httpCache.fromLua(userData.user.httpCache)
    } else {
        self.createNewUser()
    }
    Localhost.flushCurrentUserData()
}
UserManager.prototype.isCleanUser = function () {
    var self = this
    if (self.uid === kDeviceID) {
        return false
    }
    var newUserReward = self.userExtend.getNewUserReward() === 1
    if (newUserReward) {
        return false
    }
    var scores = self.getScoreRef()
    if ($len(scores) > 0) {
        return false
    }
    return true
}
UserManager.prototype.updateUserData = function (src) {
    var self = this
    if (!src) {
        return 
    }
    for (var i = 1, v = self.props[1]; v; i++, v = self.props[i]) {
        v.dispose()
    }
    if (src.headFrameId) {
        self.headFrameId = tonumber(src.headFrameId)
    }
    self.user.fromLua(src.user)
    cc.log("updateUserData")
    self.scores = table()
    if (src.scores) {
        for (var i = 1, v = src.scores[1]; v; i++, v = src.scores[i]) {
            var p = ScoreRef.new()
            p.fromLua(v)
            self.scores[i] = p
        }
        Localhost.getInstance().syncLevelScores(src.scores, true)
    }
    self.props = table()
    if (src.props) {
        for (var i = 1, v = src.props[1]; v; i++, v = src.props[i]) {
            var p = PropRefEncypt.new()
            p.fromLua(v)
            self.props[i] = p
        }
    }
    if (src.requestNum) {
        self.requestNum = src.requestNum
    }
    self.unlockInfo.fromLua(src.unlockInfo || table())
}
UserManager.prototype.getAppConfig = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    return self.appConfigRef || table()
}
UserManager.prototype.setEnergyShare = function (energyShare) {
    let self = this
    self.energyShare = energyShare
}
UserManager.prototype.getActivityById = function (id) {
    var self = this
    if (self.actInfos) {
        for (var i = 1, v = self.actInfos[1]; v; i++, v = self.actInfos[i]) {
            if (v.actId === id) {
                return v
            }
        }
    }
    return null
}
UserManager.prototype.isFirstPay = function () {
    var self = this
    return self.userExtend.getIsFristPay() > 0
}
UserManager.prototype.setFirstPayFalse = function () {
    var self = this
    return self.userExtend.setIsFristPay(0)
}
UserManager.prototype.getMsgCenterNum = function () {
    var self = this
    // WARN: maybe multi result
    return self.msgAmount.getMsgCenterNum()
    // return self.msgAmount.getTotalMsgNum()  //岛屿功能完整开发完后用这个
}
UserManager.prototype.getLeftFreegift = function () {
    var self = this
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    var maxNum = MetaManager.getInstance().getDailyMaxSendGiftCount(topLevel)
    return maxNum - UserManager.getInstance().sendGiftCount()
}
UserManager.prototype.getAcceptGiftLeft = function () {
    var self = this
    var receiveMax = MetaManager.getInstance().getDailyMaxReceiveGiftCount()
    var received = UserManager.getInstance().receiveGiftCount()
    return receiveMax - received
}
UserManager.prototype.getGiftMsgNum = function () {
    var self = this
    var totalGiftMsgNum = self.msgAmount.getGiftMsgNum()
    var receiveAvaible = self.getAcceptGiftLeft() > 0
    var sendAvailable = self.getLeftFreegift() > 0
    var sendMsgNum = self.msgAmount.getSendGiftMsgNum()
    var wantMsgNum = self.msgAmount.getWantGiftMsgNum()
    var msgNum = totalGiftMsgNum
    if (!receiveAvaible) {
        msgNum = msgNum - sendMsgNum
    }
    if (!sendAvailable) {
        msgNum = msgNum - wantMsgNum
    }
    // WARN: maybe multi result
    return Math.max(msgNum, 0)
}
UserManager.prototype.getSysMsgNum = function () {
    var self = this
    // WARN: maybe multi result
    return self.msgAmount.getSysMsgNum()
}
UserManager.prototype.setMsgCenterNum = function (num) {
    var self = this
    self.msgAmount.setMsgCenterNum(num)
}
UserManager.prototype.syncMsgAmount = function (amountTable) {
    var self = this
    self.msgAmount.fromLua(amountTable)
}
UserManager.prototype.getMsgAmountRef = function () {
    var self = this
    return self.msgAmount
}
UserManager.prototype.setGiftMsgNum = function (num) {
    var self = this
    self.msgAmount.setGiftMsgNum(num)
}
UserManager.prototype.setIslandMsgNum = function(num) {
    var self = this
    self.msgAmount.setIslandMsgNum(num)
}
UserManager.prototype.getIslandMsgNum = function() {
    var self = this
    return self.msgAmount.getIslandMsgNum()
}

UserManager.prototype.setChallengeMsgNum = function(num) {
    var self = this
    self.msgAmount.setChallengeMsgNum(num)
}
UserManager.prototype.getChallengeMsgNum = function() {
    var self = this
    return self.msgAmount.getChallengeMsgNum()
}
UserManager.prototype.getNewChallengeMsg = function () {
    var self = this
    return self.userExtend.newChallengeMsg
}
UserManager.prototype.setSysMsgNum = function (num) {
    var self = this
    self.msgAmount.setSysMsgNum(num)
}
UserManager.prototype.setLotteryLeft = function (num) {
    var self = this
    self.lotteryLeft = num
}
UserManager.prototype.isSystemMessageChecked = function (metaId) {
    var self = this
    return table.indexOf(self.checkedSystemMessages, metaId) != null
}
UserManager.prototype.saveCheckedSystemMessages = function (metaId) {
    var self = this
    if (!table.indexOf(self.checkedSystemMessages, metaId)) {
        table.insert(self.checkedSystemMessages, metaId)
        Localhost.flushCurrentUserData()
    }
}
UserManager.prototype.getIntroCheckedLevelId = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.introCheckLevelId
}
UserManager.prototype.saveIntroCheckedLevelId = function (levelId) {
    var self = this
    self.introCheckLevelId = levelId
    Localhost.flushCurrentUserData()
}
UserManager.prototype.getLocationUpdateTime = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.locationUpdateTime
}
UserManager.prototype.saveLocationUpdateTime = function (time) {
    var self = this
    self.locationUpdateTime = time
    Localhost.flushCurrentUserData()
}
UserManager.prototype.setCanFetchBetaReward = function (canFetchBetaReward) {}
UserManager.prototype.getCanFetchBetaReward = function () { return false }
UserManager.prototype.getUserRef = function () {
    return this.user
}
UserManager.prototype.getPropRef = function () {
    return this.props
}
UserManager.prototype.getFriends = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // WARN: maybe multi result
    return clone(self.friendIds)
}
UserManager.prototype.getFriendCount = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return $len(self.friendIds)
}
UserManager.prototype.isFriendCountReachMax = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    return self.getFriendCount() >= 200
}
UserManager.prototype.addFriendIds = function (uids) {
    var self = this
    for (var _ = 1, v = uids[1]; v; _++, v = uids[_]) {
        if (!self.isFriend(v)) {
            table.insert(self.friendIds, v)
        }
    }
}
UserManager.prototype.removeFriendId = function (uid) {
    var self = this
    table.removeValue(self.friendIds, uid)
}
//------------------------------------
//---	Function About User Score
//-----------------------------------
UserManager.prototype.getPassedTopLevel = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    var topLevelId = self.getUserRef().getTopLevelId()
    var scoreRef = self.getUserScore(topLevelId)
    if (scoreRef && scoreRef.star > 0) {
        return topLevelId
    } else {
        return topLevelId - 1
    }
}
UserManager.prototype.isNeedCompletionScoreRef= function () {
    return !this.scores[1]
}
UserManager.prototype.updateScoreRef = function (levelList) {
    let self = this
    return new Promise((resolve, reject) => {
        function success(evt) {
            cc.log("[scores] updateScoreRef ",evt)
            if (evt && evt.data && evt.data.scores){
                for (let i in evt.data.scores) {
                    let v = evt.data.scores[i]
                    if(v == null){
                        continue
                    }
                    let p = ScoreRef.new()
                    p.fromLua(v)
                    if(!p){
                        continue
                    }
                    self.scores[tonumber(p.levelId)] = p
                }
            }
            cc.log("[scores] updateScoreRef self.scores ",self.scores)
            resolve()
        }
        let http = GetUserScoreInfoHttp.new()
        http.addEventListener(Events.kComplete, success)
        http.addEventListener(Events.kError, (evt) => {
            reject(evt)
        })
        http.addEventListener(Events.kCancel, () => {
            reject(0)
        })
        http.load(levelList)
    })
}

UserManager.prototype.getScoreRef = function () {
    var self = this
    return self.scores
}
UserManager.prototype.getUserScore = function (levelId) {
    var self = this
    // for (var i = 1, v = self.scores[1]; v; i++, v = self.scores[i]) {
    //     if (v.levelId === levelId) {
    //         return v
    //     }
    // }
    for (let i = 1; i <= self.scores.length; i++) {
        let v = self.scores[i]
        if (v && v.levelId === levelId) {
            return v
        }
        
    }
    return null
}
//---------------------
//获取每个区域的星星数
//---------------------
UserManager.prototype.getAreaTotalStars = function (areaId, levelId) {
    var self = this
    var count = 0
    var areaRef = MetaManager.getInstance().getLevelAreaById(areaId)
    if (areaRef && areaRef.maxLevel !== 9999) {
        var $var143 = areaRef.minLevel,$limit144 = levelId && levelId || areaRef.maxLevel
        for (var k = $var143; k <= $limit144; k += 1) {
            var scoreRef = self.getUserScore(k)
            if (scoreRef) {
                count = count + scoreRef.star
            }
        }
    }
    return count
}
UserManager.prototype.addUserScore = function (userscore) {
    var self = this
    if (self.getUserScore(userscore.levelId) == null) {
        table.insert(self.scores, userscore)
        Localhost.getInstance().addUserScore(userscore.encode())
    } else {
        assert(false)
    }
    cc.log("[scores] addUserScore ", self.scores)
}
UserManager.prototype.updateUserScore = function (levelId) {
    var self = this
    for (var i in self.scores) {
        var v = self.scores[i]
        if (v.levelId === levelId) {
            Localhost.getInstance().addUserScore(v.encode())
        }
    }
    cc.log("[scores]updateUserScore ", levelId,self.scores)
}
UserManager.prototype.removeUserScore = function (levelId) {
    var __VA_ARG = $slice(arguments, 1)
    var self = this
    assert(type(levelId) === "number")
    assert($len(table([2, __VA_ARG])) === 0)
    for (var i = 1, v = self.scores[1]; v; i++, v = self.scores[i]) {
        if (v.levelId === levelId) {
            table.remove(self.scores, i)
            return 
        }
    }
    assert(false)
}
UserManager.prototype.addUserProp = function (prop) {
    var self = this
    if (self.getUserProp(prop.itemId) == null) {
        table.insert(self.props, prop)
    }
}
UserManager.prototype.getUserProp = function (itemId) {
    var self = this
    assert(type(itemId) === "number")
    for (var i in self.props) {
        var v = self.props[i]
        if(v == null){
            continue
        }
        if (v.itemId === itemId) {
            return v
        }
    }
    return null
}
UserManager.prototype.setUserPropNumber = function (itemId, newNumber) {
    var self = this
    assert(type(itemId) === "number")
    assert(type(newNumber) === "number")
    assert(newNumber >= 0)
    for (var i in self.props) {
        let v = self.props[i]
        if (!v) {
            continue
        }
        if (v.itemId === itemId) {
            v.setNum(newNumber)
            return 
        }
    }
    //assert(false)
    // Not Record This Prop Before
    // Add A New Prop Record
    var newProp = PropRefEncypt.new()
    newProp.itemId = itemId
    newProp.setNum(newNumber)
    self.addUserProp(newProp)
}
// add in ver1.25
UserManager.prototype.addRewards = function (rewards) {
    var self = this
    if (type(rewards) === "table") {
        for (var _ in rewards) {
            var v = rewards[_]
            if (v.itemId === 2) {
                self.user.setCoin(self.user.getCoin() + v.num)
            } else if (v.itemId === 14) {
                self.user.setCash(self.user.getCash() + v.num)
            } else {
                self.addUserPropNumber(v.itemId, v.num)
            }
        }
    }
}
UserManager.prototype.getUserPropNumber = function (itemId) {
    var self = this
    assert(type(itemId) === "number")
    var userProp = self.getUserProp(itemId)
    if (userProp) {
        // WARN: maybe multi result
        return userProp.getNum()
    }
    return 0
}
UserManager.prototype.addUserPropNumber = function (itemId, deltaNumber) {
    var self = this
    assert(itemId)
    assert(type(itemId) === "number")
    assert(deltaNumber)
    assert(type(deltaNumber) === "number")
    if (ItemType.isTimeProp(itemId)) {
        self.addTimeProp(itemId, deltaNumber)
    } else {
        var curNumber = self.getUserPropNumber(itemId)
        assert(Number.isInteger(curNumber))
        var newNumber = curNumber + deltaNumber
        if (newNumber < 0) {
            newNumber = 0
        }
        self.setUserPropNumber(itemId, newNumber)
    }
}
UserManager.prototype.mergeTimeProps = function (timeProps) {
    var self = this
    self.timeProps = table()
    if (!timeProps) {
        return 
    }
    for (var i = 1, v = timeProps[1]; v; i++, v = timeProps[i]) {
        var p = TimePropRef.new()
        p.fromLua(v)
        var newProp = true
        for (var _ in self.timeProps) {
            var prop = self.timeProps[_]
            if (prop.itemId === p.itemId && prop.expireTime === p.expireTime) {
                prop.num = prop.num + p.num
                newProp = false
            }
        }
        if (newProp) {
            table.insert(self.timeProps, p)
        }
    }
    self.sortTimeProps()
}
UserManager.prototype.getAndUpdateTimeProps = function () {
    var self = this
    // print("getAndUpdateTimeProps:", table.tostring(self.timeProps))
    var timeProps = table()
    if ($len(self.timeProps) > 0) {
        var curTimeInSec = Localhost.timeInSec()
        for (var k in self.timeProps) {
            var v = self.timeProps[k]
            // 转为s计算更准确
            if (Math.floor(v.expireTime / 1000) > curTimeInSec && v.num > 0) {
                table.insert(timeProps, v)
            }
        }
    }
    self.timeProps = timeProps
    self.sortTimeProps()
    return self.timeProps
}
// 将限时道具按过期时间从小到大排列,方便显示和扣除
UserManager.prototype.sortTimeProps = function () {
    var self = this
    table.sort(self.timeProps, function (a, b) {
        return a.expireTime < b.expireTime
    })
}


//add限时无限次道具
UserManager.prototype.addInfiniteTimeProp = function (itemId, num) {
    var self = this

    var propMeta = MetaManager.getInstance().getPropMeta(itemId)
    let metaPropId = UserPropData.getInfiniteMetaPreProp(itemId)[1]

    for (var _ in self.timeProps) {
        var prop = self.timeProps[_]
        if (prop.itemId === metaPropId) {
            prop.expireTime = Math.max(Localhost.time(), prop.expireTime) + propMeta.expireTime * num
            // hasprop = true
            return
        }
    }

    let p = TimePropRef.new()
    p.itemId = metaPropId
    p.num = 1
    p.expireTime = Localhost.time() + propMeta.expireTime * num
    table.insert(self.timeProps, p)
}
UserManager.prototype.addTimeProp = function (itemId, num) {
    var self = this
    var propMeta = MetaManager.getInstance().getPropMeta(itemId)
    if (propMeta && (propMeta.expireTime || propMeta.fixedExpireTime)) {
        let p = TimePropRef.new()
        p.itemId = itemId
        p.num = num

        if (propMeta.fixedExpireTime){
            p.expireTime = getEndTimeByTime(propMeta.fixedExpireTime)
        }else{
            p.expireTime = Localhost.time() + propMeta.expireTime
        }
        table.insert(self.timeProps, p)
        self.mergeTimeProps(self.timeProps)
    }
}
UserManager.prototype.getUserTimePropNumber = function (itemId) {
    var self = this
    var num = 0
    for (var _ in self.timeProps) {
        var v = self.timeProps[_]
        if (v.itemId === itemId) {
            num = num + v.num
        }
    }
    return num
}
UserManager.prototype.getUserTimePropNumberAfterTime = function (itemId, time) {
    var self = this
    var num = 0
    for (var _ in self.timeProps) {
        var v = self.timeProps[_]
        if (v.itemId === itemId && v.expireTime > time) {
            num = num + v.num
        }
    }
    return num
}
UserManager.prototype.getFirstTimePropExpireTime = function (itemId) {
    var self = this
    for (var i = 1, v = self.timeProps[1]; v; i++, v = self.timeProps[i]) {
        if (v.itemId === itemId) {
            return v.expireTime
        }
    }
    return 0
}
UserManager.prototype.getFirstTimePropExpireTimeAfterTime = function (itemId, time) {
    var self = this
    for (var i = 1, v = self.timeProps[1]; v; i++, v = self.timeProps[i]) {
        if (v.itemId === itemId && v.expireTime > time) {
            return v.expireTime
        }
    }
    return 0
}
UserManager.prototype.useTimeProp = function (itemId) {
    var self = this
    // print("UserManager:useTimeProp:", itemId)
    if (self.getUserTimePropNumber(itemId) < 1) {
        return false
    }
    for (var i = 1, v = self.timeProps[1]; v; i++, v = self.timeProps[i]) {
        if (itemId === v.itemId && v.num > 0) {
            v.num = v.num - 1
            if (v.num === 0) {
                table.remove(self.timeProps, i)
            }
            return true
        }
    }
    return false
}
UserManager.prototype.addUserDeco = function (deco) {
    var self = this
    if (self.getUserDeco(deco.itemId) == null) {
        table.insert(self.decos, deco)
    }
}
UserManager.prototype.getUserDeco = function (itemId) {
    var self = this
    for (var i = 1, v = self.decos[1]; v; i++, v = self.decos[i]) {
        if (v.itemId === itemId) {
            return v
        }
    }
    return null
}
UserManager.prototype.addUserFunc = function (func) {
    var self = this
    if (self.getUserFunc(func.itemId) == null) {
        table.insert(self.funcs, func)
    }
}
UserManager.prototype.getUserFunc = function (itemId) {
    var self = this
    for (var i = 1, v = self.funcs[1]; v; i++, v = self.funcs[i]) {
        if (v.itemId === itemId) {
            return v
        }
    }
    return null
}
UserManager.prototype.getDailyBoughtGoodsNumById = function (goodsId) {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().getBuyedGoodsNumber(goodsId)
}
UserManager.prototype.addBuyedGoods = function (goodsId, num) {
    var self = this
    self.getDailyData().addBuyedGoods(goodsId, num)
}
UserManager.prototype.addBagBuyCountByOne = function () {
    var self = this
    if (self.bag.buyCount < 4) {
        self.bag.buyCount = self.bag.buyCount + 1
    }
}
UserManager.prototype.getBagRef = function () {
    var self = this
    return self.bag
}
UserManager.prototype.isFriend = function (uid) {
    var self = this
    // WARN: maybe multi result
    return table.includes(self.friendIds, uid)
}
UserManager.prototype.getWantIds = function () {
    var self = this
    var res = self.getDailyData().getWantIds()
    if (type(res) !== "table") {
        res = table()
    }
    return res
}
UserManager.prototype.addWantIds = function (ids) {
    var self = this
    self.getDailyData().addWantIds(ids)
}
UserManager.prototype.sendGiftCount = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().getSendGiftCount()
}
UserManager.prototype.incSendGiftCount = function () {
    var self = this
    self.getDailyData().incSendGiftCount()
}
UserManager.prototype.receiveGiftCount = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().getReceiveGiftCount()
}
UserManager.prototype.incReceiveGiftCount = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().incReceiveGiftCount()
}
UserManager.prototype.decReceiveGiftCount = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().decReceiveGiftCount()
}
UserManager.prototype.getActiveSendIds = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().getActiveSendIds()
}
UserManager.prototype.addActiveSendId = function (sendId) {
    var self = this
    self.getDailyData().addActiveSendId(sendId)
}
UserManager.prototype.getPassiveSendIds = function () {
    var self = this
    // WARN: maybe multi result
    return self.getDailyData().getPassiveSendIds()
}
UserManager.prototype.addPassiveSendId = function (sendId) {
    var self = this
    self.getDailyData().addPassiveSendId(sendId)
}
UserManager.prototype.addNearbyRequestCount = function () {
    var self = this
    self.getLocalDailyData().addNearbyRequestCount()
    Localhost.getInstance().flushCurrentUserData()
}
UserManager.prototype.isNearbyRequestAvailable = function () {
    var self = this
    // WARN: maybe multi result
    return self.getLocalDailyData().isNearbyRequestAvailable()
}
UserManager.prototype.isLinkFriendRequestAvailable = function () {
    var self = this
    // WARN: maybe multi result
    return self.getLocalDailyData().isLinkFriendRequestAvailable()
}
UserManager.prototype.addLinkFriendRequestCount = function (count) {
    var self = this
    self.getLocalDailyData().addLinkFriendRequestCount(count)
    Localhost.flushCurrentUserData()
}
UserManager.prototype.flushSendGiftInfo = function () {
    var self = this
    var day = Localhost.timeInDay()
    self.dailySendInfo.addSendIds(day, clone(self.getActiveSendIds()))
    Localhost.getInstance().flushCurrentUserData()
}
UserManager.prototype.setSendFirst = function (uidList) {
    var self = this
    var day = Localhost.timeInDay()
    self.dailySendInfo.setSendFirst(day, uidList)
    Localhost.getInstance().flushCurrentUserData()
}
UserManager.prototype.getSendInfo = function (day) {
    var self = this
    // WARN: maybe multi result
    return self.dailySendInfo.getInfo(day)
}
UserManager.prototype.getUserExtendRef = function () {
    var self = this
    return self.userExtend
}
UserManager.prototype.getUserShowRef = function () {
    var self = this
    return self.userShow
}
UserManager.prototype.isUserRewardBitSet = function (bitIndex) {
    var self = this
    self.userReward = self.userReward || table()
    self.userReward.rewardFlag = self.userReward.rewardFlag || 0
    if (bitIndex < 1) {
        bitIndex = 1
    }
    var mask = Math.pow(2, bitIndex - 1)
    return mask === bit.band(self.userReward.rewardFlag, mask)
}
UserManager.prototype.setUserRewardBit = function (bitIndex, setToTrue) {
    var self = this
    self.userReward = self.userReward || table()
    self.userReward.rewardFlag = self.userReward.rewardFlag || 0
    if (bitIndex < 1) {
        bitIndex = 1
    }
    var mask = Math.pow(2, bitIndex - 1)
    if (setToTrue === true || setToTrue === 1) {
        self.userReward.rewardFlag = bit.bor(self.userReward.rewardFlag, mask)
    } else if (mask === bit.band(self.userReward.rewardFlag, mask)) {
        self.userReward.rewardFlag = self.userReward.rewardFlag - mask
    }
    return self.userReward.rewardFlag
}
UserManager.prototype.getDimePlatforms = function () {
    var self = this
    return self.dimePlat
}
UserManager.prototype.getDimeProvinces = function () {
    var self = this
    return self.dimeProvince
}
UserManager.prototype.getNewUserTaskInfo = function () { return null }
UserManager.prototype.getInviter = function () {
    var self = this
    return self.userExtend.inviter
}
UserManager.prototype.getInviteFriendNum = function () {
    var self = this
    return self.userExtend.inviteFriendCount
}
UserManager.prototype.getInviteCountRewardMeta = function () {
    var self = this
    var metaConfig = MetaManager.getInstance().invite_count_reward
    table.sort(metaConfig, function (a, b) {
        return a.id < b.id
    })
    var inviteCountReward = table()
    var tmp = 0
    var maxGotId = 0
    var $limit255 = $len(metaConfig)
    for (var index = 1; index <= $limit255; index += 1) {
        tmp = tmp + 2 ^ (index - 1)
        var metaId = metaConfig[index].id
        if (inviteCountReward[metaId] == null) {
            inviteCountReward[metaId] = bit.band(tmp, self.userExtend.inviteCountFlag) === tmp
        }
        hasGot = inviteCountReward[metaId]
        if (hasGot && metaId > maxGotId) {
            maxGotId = metaId
        }
    }
    return metaConfig[maxGotId + 1]
}
//-------------------------
//判断后端是否在一个平台
//-------------------------
UserManager.prototype.isSameInviteCodePlatform = function (code) {
    var self = this
    // body
    function isYYBCode(_code) {
        var codeNum = tonumber(_code)
        codeNum = Math.floor(codeNum / 1000000000)
        if (1 <= codeNum && codeNum <= 3) {
            return true
        }
        return false
    }
    return isYYBCode(code) === isYYBCode(self.inviteCode)
}
UserManager.prototype.isYYBInviteCodePlatform = function (code) {
    var self = this
    code = code || self.inviteCode
    var codeNum = tonumber(code)
    codeNum = Math.floor(codeNum / 1000000000)
    if (1 <= codeNum && codeNum <= 3) {
        return true
    }
    return false
}
UserManager.prototype.setIngameBuyGuide = function (xvar) {
    var self = this
    self.ingameBuyPropsGuide = xvar
}
UserManager.prototype.getIngameBuyGuide = function () {
    var self = this
    if (self.ingameBuyPropsGuide === 1) {
        self.ingameBuyPropsGuide = 0
        return true
    }
    return false
}
UserManager.prototype.getProfileRef = function () {
    var self = this
    return self.profile
}
UserManager.prototype.isWechatNeverSigned = function () {
    var self = this
    return self.userExtend.wxIngameState === 0
}
UserManager.prototype.isWechatSigned = function () {
    var self = this
    return self.userExtend.wxIngameState === 1
}
UserManager.prototype.isWechatUnSigned = function () {
    var self = this
    return self.userExtend.wxIngameState === 2
}
UserManager.prototype.isAliNeverSigned = function () {
    var self = this
    return self.userExtend.aliIngameState === 0
}
UserManager.prototype.isAliSigned = function () {
    var self = this
    return self.userExtend.aliIngameState === 1
}
UserManager.prototype.isAliUnSigned = function () {
    var self = this
    return self.userExtend.aliIngameState === 2
}
UserManager.prototype.getAliKfMonthlyLimit = function () {
    var self = this
    return self.userExtend.aliMonthRmb || 0
}
UserManager.prototype.setAliKfMonthlyLimit = function (value) {
    var self = this
    self.userExtend.aliMonthRmb = value
}
UserManager.prototype.getAliKfDailyLimit = function () {
    var self = this
    return self.userExtend.aliDailyRmb || 0
}
UserManager.prototype.setAliKfDailyLimit = function (value) {
    var self = this
    self.userExtend.aliDailyRmb = value
}
UserManager.prototype.setVipMonthCd = function (countdownSecond) {
    var self = this
    if (self.settings && self.settings.data && countdownSecond > 0) {
        self.settings.data["mcEndtime"] = new Date().getTime() + countdownSecond * 1000
    } else {
        self.settings.data["mcEndtime"] = 0
    }
}
UserManager.prototype.isVipMonth = function () {
    var self = this
    var endtime = self.getSettingByKey("mcEndtime", 0)
    if (endtime) {
        return new Date().getTime() / 1000 < endtime
    } else {
        return false
    }
}
UserManager.prototype.getUpdateInfo = function () {
    var self = this
    return self.updateInfo
}
UserManager.prototype.getUpdateRewards = function () {
    return null;
}
UserManager.prototype.setUpdateRewards = function (data) {}
UserManager.prototype.getBranchInfo = function () {
    var self = this
    return self.branchs
}
UserManager.prototype.getMarkRef = function () {
    var self = this
    return self.mark
}
UserManager.prototype.setMarkRef = function (data, isNewMark) {
    var self = this
    self.mark = MarkRef.create().fromLua(data, isNewMark)
}
UserManager.prototype.getUnlockInfo = function () {
    var self = this
    return self.unlockInfo
}
UserManager.prototype.cacheHttp = function (endPoint, body) {
    var self = this
    self.httpCache.cacheHttp(endPoint, body)
}
UserManager.prototype.setSyncSerial = function (seq) {
    var self = this
    self.httpCache.setSyncSerial(seq)
}
UserManager.prototype.getSyncSerial = function () {
    var self = this
    // WARN: maybe multi result
    return self.httpCache.getSyncSerial()
}
UserManager.prototype.clearUsedHttpCache = function (list) {
    var self = this
    self.httpCache.removeUsedHttpCache(list)
}
UserManager.prototype.getCachedHttpData = function () {
    var self = this
    // WARN: maybe multi result
    return self.httpCache.getCachedHttp()
}
UserManager.prototype.clearCachedHttp = function () {
    var self = this
    self.httpCache.clearCachedHttp()
}
//-----------------------------------------
//持久化user info
//------------------------------------------
UserManager.prototype.flushUserData = function () {
    var self = this
    // body
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserManager.prototype.getContinueLoginDays = function () {
    var self = this
    return self.continueLoginDays
}
UserManager.prototype.getGroupInfos = function () {
    var self = this
    return self.groupInfos
}
UserManager.prototype.getInviteStatus = function () {
    var self = this
    // body
    return self.userExtend.invitePopup
}
UserManager.prototype.getVerifiedPhoneNumber = function () {
    var self = this
    // body
    if (self.userExtend.identifyNum && self.userExtend.identifyNum !== "") {
        return self.userExtend.identifyNum
    }
}
UserManager.prototype.setVerifiedPhoneNumber = function (num) {
    var self = this
    // body
    self.userExtend.identifyNum = num
    Localhost.flushCurrentUserData()
}
UserManager.prototype.shouldShowBreakIceIcon = function () {
    let self = this
    // let settings = self.settings.data || {}
    // if (!settings.isShowBreakIceGiftEntrance || Math.abs(settings.todayBreakIceGiftCD - Localhost.timeInSec()) < 3) {
    //     return false
    // }else {
    //     return true
    // }
    // let isFristPay = UserManager.getInstance().isFirstPay()
    // if (!isFristPay) {
    //     return false
    // }
    // let popoutStep = 30
    // let popoupStartLevel = 21
    // let start = popoupStartLevel
    // let topLevelId = UserManager.getInstance().user.topLevelId
    // while(start < topLevelId){
    //     start = start + popoutStep
    // }
    // if (start !== topLevelId) {
    //     return false
    // }
    // let poptime = UserLocalSettings.getSetting("show.me.the.money.pop.end.time") || 0
    // if (poptime !== 0 && poptime >= Localhost.timeInSec()) {
    //     return true
    // }else if (poptime !== 0 && poptime < Localhost.timeInSec()) {
    //     UserLocalSettings.setSetting("show.me.the.money.pop.end.time", 0)
    //     return false
    // }else {
    //     return true
    // }


    if (!self.canIconShow("yiYuanGift")) {
        return false
    }

    // 是否购买了一元礼包
    if (self.userExtend.wxYiYuanGiftHasBuy) {
        return false
    }

    let snsInstance = require("clover/sns/SnsProxy").getInstance()
    let isIOS = snsInstance.getSystemPlatfrom() === SystemPlatform.IOS
    if (isIOS) {
        return false
    }
    return true
}
UserManager.prototype.setBreakIceActivityRewaed = function () {
    // let self = this
    // let settings = self.settings.data || {}
    // settings.isShowBreakIceGiftEntrance = false
    let self = this
    UserLocalSettings.setSetting("show.me.the.money.pop.end.time", 0)
    self.setFirstPayFalse()
}
UserManager.prototype.isWantedActivityStarting = function () {
    return false;
}
UserManager.prototype.getSettingByKey = function (key, defaultValue) {
    let self = this
    return self.settings.data[key] || defaultValue
}
UserManager.prototype.setSettingByKey = function (key, value) {
    let self = this
    if (!key || !value) return
    self.settings.data[key] = value
}
UserManager.prototype.getWantedActivityEndTime = function () {
    return 0;
}
UserManager.prototype.getWantedActivityStartTime = function () {
    return 0;
}
UserManager.prototype.isTestGroup = function (mod, ...units) {
    // 不指定则单数变化，偶数不变
    if (!mod) {
        return this.uid % 2 === 1
    }
    
    let r = this.uid % mod
    for (let i = 0; i < units.length; i++) {
        if (r === units[i]) {
            return true
        }
    }
    return false
}
UserManager.prototype.initActMissionHelper = function () {
    let self = this
    let info = self.getActivityById(12)
    if (info) {
        let oldday = UserLocalSettings.getSetting("act_mission_helper_12_day", 0)
        let today = Localhost.timeInDay()
        if (oldday === today) {
            info.rewardFlag =  UserLocalSettings.getSetting("act_mission_helper_12_daily", 0)
        }
    }
}
UserManager.prototype.getExtraCashBuffInfo = function () {
    let self = this
    let endtime = self.settings.data["qCashPanicBuyingEndTime"] || 0
    let rate = self.settings.data["qCashPanicBuyingRate"] || 0
    return [endtime, rate]
}
UserManager.prototype.isExtraCashBuffCanUseLessLimit = function () {
    let self = this
    let endtime = self.settings.data["qCashPanicBuyingEndTime"] || 0
    if (endtime < Localhost.time()) {
        return false
    }
    return self.isFirstPay()
}
UserManager.prototype.isExtraCashBuffCanUse = function () {
    let self = this
    let app = META.user.app
    if (app !== PLATFORM_DEF.SQ) {
        return false
    }
    let [endTime, rate] = self.getExtraCashBuffInfo()
    let now = Localhost.time()
    if (now > endTime) {
        return false
    }
    let isFirstPay = self.isFirstPay()
    let platform = META.user.serverid
    if (platform === DEVIDE_ANDROID && isFirstPay) {
        return true
    }else {
        return false
    }
}
UserManager.prototype.getExtraCashBuffRate = function () {
    let self = this
    return self.settings.data["qCashPanicBuyingRate"] || 0
}

UserManager.prototype.getLeadUrl = function () {
    let self = this
    return self.settings.data.leadUrl
}
UserManager.prototype.shouldShowSurveyAction = function () {
   return false;
}
UserManager.prototype.chestActivityCanStart = function () {
    return false;
}
UserManager.prototype.shouldShowLeadAction = function () {
    let topLevel = UserManager.getInstance().user.topLevelId
    if (topLevel >= 25 || !switchs.canLead) {
        return false
    }else {
        return true
    }
}
UserManager.prototype.showVipPrivilegesBtn = function () {
    let self = this
    return self.settings.data.showVipPrivilegesButton
}
UserManager.prototype.hasFetchLeadRewards = function () {
    var self = this
    return self.userExtend.hasFetchLeadRewards
}
UserManager.prototype.setHasFetchLeadRewards = function () {
    var self = this
    self.userExtend.hasFetchLeadRewards = true
}
//---------------------------------------------------------
//无限前置道具属性
//---------------------------------------------------------
UserManager.prototype.isInfiPrePropState = function (levelId) {
    let self = this
    let now = Localhost.time()
    let time = self.getInfiPrePropTime(levelId)
    return time >= now
}
UserManager.prototype.getInfiPrePropTime = function (levelId) {
    let self = this
    // check level
    let topLevel = self.getUserRef().getTopLevelId()
    if (levelId < topLevel) {
        return -1
    } else if (levelId === topLevel) {
        let score = self.getUserScore(levelId)
        if (score != null && score.star > 0) {
            return -1
        } else {
            // WARN: maybe multi result
            return self.getUserExtendRef().getPrePropNoLimitTime()
        }
    }
    return -1
}
UserManager.prototype.addInfiPrePropTime = function (duration) {
    let self = this
    // set
    let now = Localhost.time()
    let extend = self.getUserExtendRef()
    extend.setPrePropNoLimitTime(now + duration)
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserManager.prototype.clearInfiPrePropTime = function () {
    let self = this
    self.getUserExtendRef().setPrePropNoLimitTime(0)
}
UserManager.prototype.getInvitationGiftConfig = function() { return null }
UserManager.prototype.getInvitationGiftFirstConfig = function() {}
UserManager.prototype.getSystemConfig = function (name) {
    let self = this
    return self.systemConfig[name]
}
UserManager.prototype.getIslandsInfo = function () {
    return this.islandsInfo || {topId: 1, canGetReward: false}
}
UserManager.prototype.updateIslandsInfo = function (info) {
    this.islandsInfo = info;
}
UserManager.prototype.getIslandsConfig = function () {
    // return this.systemConfig.islands || table(
    //     {img:"http://ff.happyelements.com/xclover-test/resource/homeConfigRes/island01.png", id:1, level:0}, 
    //     {img:"http://ff.happyelements.com/xclover-test/resource/homeConfigRes/island05.png", id:2, level:60}
    // )
    // let delta = 30
    // for (let index = 1, v = this.systemConfig.islands[index]; v; v = this.systemConfig.islands[++index]) {
    //     if (!v.minLevel || !v.maxLevel) {
    //         v.minLevel = v.level + 1
    //         v.maxLevel = v.level + delta
    //     }
    // }
    return this.systemConfig.islands
}
UserManager.prototype.getIslandConfigById = function (id) {
    let self = this
    let configs = self.getIslandsConfig()
    for (let index = 1, v = configs[index]; v; v = configs[++index]) {
        if (v.id === id) {
            return v
        }
    }
}
UserManager.prototype.getTopIslandConfig = function () {
    // let islandsConfig = this.getIslandsConfig()
    let topId = this.getTopIslandId()
    return this.getIslandConfigById(topId)
}
UserManager.prototype.getTopIslandId = function () {
    let localId = this.getCurrentIslandsIdByLevel()
    let serverId = this.getIslandsInfo().topId
    return Math.max(localId, serverId)
}
/**
 * 只能检查当前关卡等级是否满足解锁条件，无法判断星星数
 */
UserManager.prototype.canUnlockNewIsland = function () {
    let self = this
    let topLevelId = self.user.topLevelId - 1;
    let score = UserScore.getInstance().getScore(topLevelId)
    if (score.star <= 0) {
        return false
    }

    let maxlevel = self.getMaxLevelServer();
    if (topLevelId >= maxlevel) {
        return false;
    }

    let islandsConfig = this.getIslandsConfig()
    for (let index = 1, v = islandsConfig[index]; v; v = islandsConfig[++index]) {
        if (topLevelId === v.maxLevel) {
            return true
        }
    }
    return false
}

let specialIslandsId = 1001
UserManager.isSpecialIsland = function (config = {}) {
    if (cc.isObject(config)) {
        return config.id >= specialIslandsId
    }
    let id = config
    if (typeof config === "string") {
        id = parseInt(id)
    }
    return id >= specialIslandsId
}
UserManager.prototype.getCurrentIslandsIdByLevel = function () {
    let islandsConfig = this.getIslandsConfig() || table()
    let topId = 0
    let topLevelId = this.user.topLevelId;
    let maxLevelId = this.getMaxLevelServer();
    let compareId = Math.min(topLevelId, maxLevelId);
    for (let index = 1, v = islandsConfig[index]; v; v = islandsConfig[++index]) {
        if ( !UserManager.isSpecialIsland(v.id) && v.unlock !== IslandUnlockType.placeHolder &&  compareId <= v.maxLevel) {
            topId = v.id
            break
        }
    }
    return topId
}
/**
 * 当前进度岛屿是否需要解锁
 */
UserManager.prototype.topIslandNeedUnlock = function () {
    let topLevelId = this.user.topLevelId - 1;
    if (topLevelId === 0) {
        //  新手第一关不用解锁
        return false;
    }
    let islandsConfig = this.getIslandsConfig() || table();
    let islandsInfo = this.getIslandsInfo();

    for (let index = 1, v = islandsConfig[index]; v; v = islandsConfig[++index]) {
        if (topLevelId === v.minLevel) {
            if (islandsInfo.topId !== v.id) {
                return true;
            } else {
                return false;
            }
        }
    }
    return false;
}
UserManager.prototype.getStarChestConfig = function () {
    // return this.systemConfig.starChest || {starCount:20}
    return this.starChestInfo
}
UserManager.prototype.getStarChestInfo = function () {
    return this.starChestInfo
}
UserManager.prototype.updateStarChestInfo = function (info) {
    if (info && info.type && (info.starCount >= 0) && info.rewards) {
        this.starChestInfo = info
    }
}
UserManager.prototype.getCurrentStarChestRewards = function () {
    let self = this
    return self.starChestInfo.rewards || table(
        {itemId: 14, num: 20},
        {itemId: 10005, num: 4}
    )
}
UserManager.prototype.canOpenChest = function () {
    // return this.starChestInfo.starCount >= (this.systemConfig.starChest.starCount || 20)
    return this.starChestInfo.starCount >= this.starChestInfo.starCountOpen
}
UserManager.prototype.addStarChestNewStar = function (num) {
    this.starChestInfo.starCount += num
}
UserManager.prototype.starDrawUseStar = function (num) {
    this.starChestInfo.starCount -= num
}
UserManager.prototype.getMaxLevelServer = function () {
    return this.systemConfig.maxLevel || 400
}
UserManager.prototype.reachTopLevel = function () {
    let self = this
    let level = UserManager.getInstance().user.topLevelId
    let maxlevel = UserManager.getInstance().getMaxLevelServer()
    if (level > maxlevel) {
        return true
    }
    if (level === maxlevel) {
        let score = UserScore.getInstance().getScore(level)
        if (score.star > 0) {
            return true
        }
        return false
    }
    return false
}
UserManager.prototype.isOneStepActivityOpen = function () {
    let self = this
    return self.settings.data.onePassOpen
}
UserManager.prototype.isTimeModeActivityOpen = function () {
    let self = this
    // return true
    return self.settings.data.timeMatchOpen
}
UserManager.prototype.getIconSetting = function (icon) {
    return this.iconMap && this.iconMap[icon] || {}
}

UserManager.prototype.canIconShow = function (icon) {
    let self = this
    let setting = self.getIconSetting(icon)
    if(setting && setting.show && self.user.topLevelId >= setting.minLevel) 
    {
        return true;
    }
    return false;
}
// mini 小程序支付  H5网页客服支付
UserManager.prototype.getIosPayType = function () {
    let str = "mini"//mini
    if (!this.iosPay) str = "h5"
    console.log("iospay getIosPayType ",str)
    return str

}
UserManager.prototype.canIosPay = function () {
    console.log("iospay caniospay ",this.iosPay)
    // return true
    if (this.isInReview()) {
        console.log("iospay caniospay 审核中不开放ios支付功能")
        return false
    }
    return this.iosPay || this.iosPayService;
}
// 是否使用过客服支付
UserManager.prototype.isUsedCustomerPay = function () {
    return this.iosPayServiceUse
}
//除wanba外iospay为true的平台，便于之后其他平台扩展
UserManager.prototype.canIosToMiniPay = function () {
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    // cc.log("[PrivacyUtil] PrivacyUtil isOpen pf ",pf);
 
    console.log("iospay canIosToMiniPay ", this.iosPay && pf != "wanba_ts")
    // return true
    
    return this.canIosPay() && pf != "wanba_ts" && isPlatformIOS();
}

UserManager.prototype.showBreakIceIconReddot = function () {
    let self = this
    if(self.userExtend.wxYiYuanGiftHasBuy) {
        return false;
    }
    let invitees = self.getWxYiYuanInvitees()
    
    if(invitees.length == 3) {
        return true;
    }
    let oldFriends = UserLocalSettings.getSetting("wxYiYuanInvitees");
    if(!oldFriends && invitees) {
        oldFriends = []
        UserLocalSettings.setSetting("wxYiYuanInvitees", invitees);
    }
    let difference = []
    if(invitees) {
        difference = invitees.filter(function(v){ return oldFriends.indexOf(v) === -1 }).concat(oldFriends.filter(function(v){ return invitees.indexOf(v) === -1 }))
    }
    if(difference.length > 0) {
        return true;
    }
    return false;
}
UserManager.prototype.canFetchYiYuanGift = function () {
    let self = this
    if(self.userExtend.wxYiYuanGiftHasBuy) {
        return false;
    }
    if(self.getYiYuanInviteeCount() == 3) {
        return true;
    }
    return false;
}
UserManager.prototype.getYiYuanInviteeCount = function () {
    let self = this
    return self.getWxYiYuanInvitees().length;
}
UserManager.prototype.getWxYiYuanInvitees = function() {
    let self = this
    let invitees = self.userExtend.wxYiYuanInvitees
    if(!invitees) {
        return [];
    }
    // 从luaTable转成普通数组
    if(!invitees[0]) {
        invitees.shift()
    }
    return invitees
}
UserManager.prototype.isGoldMatchActivityOpen = function () {
    let self = this
    // return true
    return self.settings.data.goldMatchOpen
}

UserManager.prototype.setInNewLevelEnd = function(f){
    let self = this;
    if (f){
        self.inNewLevelEnd = true;
    }else{
        self.inNewLevelEnd = false;
    }
}

UserManager.prototype.getInNewLevelEnd = function(){
    let self = this;
    return self.inNewLevelEnd;
}

UserManager.prototype.setLastShowOffTime = function(time){
    cc.UserDefault.getInstance().setStringForKey(LOCAL_LAST_SHOWOFF_TIME, time);
}

UserManager.prototype.getLastShowOffTime = function(){
    var time = cc.UserDefault.getInstance().getStringForKey(LOCAL_LAST_SHOWOFF_TIME, "0");
    return time;
}

// 新分享裂变的屏蔽组
UserManager.prototype.isAddStepBlock = function(){
    if (window.mini){
        if (mini.getPlatform() == MiniPlatform.oppoQuickgame 
            || mini.getPlatform() == MiniPlatform.vivo 
            || mini.getPlatform() == MiniPlatform.honorQuickgame){
            // 新裂变分享oppo和vivo不用
            return true
        }
        var userLimit = UserManager.getInstance().getUserExtendRef().ipRegionLimit;
        var userLimit2 = null;
        cc.log("----userLimit", userLimit)
        for (var i in userLimit){
            if (userLimit[i].funId == IpActivityType.addstap_share){
                userLimit2 = userLimit[i].status;
            }
        }
        if (userLimit2 == null){
            return false;
        }
        for (var i in userLimit2){
            // 1：ip屏蔽，2：链接屏蔽
            if (userLimit2[i] == 1 || userLimit2[i] == 2){
                return true;
            }
        }
        cc.log("----userLimit2", userLimit2)
        var limitCfg = IpRegionLimitManager.getInstance().limitSceneList[IpActivityType.addstap_share];
        if (limitCfg){
            limitCfg = limitCfg[mini.getPlatform()];
            cc.log("----limitCfg", limitCfg);
            if (limitCfg){
                for (var i in limitCfg){
                    for (var j in userLimit2){
                        cc.log(limitCfg[i], userLimit2[j]);
                        if (limitCfg[i] == userLimit2[j]){
                            return true;
                        }
                    }
                }
            }
        }
    }
    return false;
}
// 获取最后一次付费到现在的天数
UserManager.prototype.getLastPayDiffDay = function(){
    let cur_time = Localhost.time();
    let time1 = cur_time;
    let time2 = this.getUserExtendRef().lastPayTime;
    let day_num = getDayDiffByTime(time1, time2);
    return day_num;
}
// 是否开启海滨之星
UserManager.prototype.isSeasideStarOpen = function () {
    let self = this
    // return true
    return self.settings.data.coastStarOpen
}

// 是否开启冠军赛
UserManager.prototype.isChampionOpen = function () {
    let self = this
    // return true
    return self.settings.data.championOpen
}

// 是否开启广告任务
UserManager.prototype.isAdTaskServerOpen = function () {
    let self = this
    // return true
    return self.settings.data.adTaskOpen
}
// gdt_vid是腾讯，clue_token是巨量，rongyao2307是荣耀投放
// 获取用户来源类型
// 1：巨量；
// 2：腾讯；
// 0：未知
// 11: rongyao2307 荣耀投放渠道标识
// 200：腾讯iaa广告策略渠道
UserManager.prototype.getUserAdChannel = function () {
    let self = this
    // return true
    
    return self.userLabel.adSource
    // return self.settings.data.adTaskOpen
}
UserManager.prototype.isUseIAA = function () {
    // return true
    let pf = isWechatGameEnv() ? mini.getPlatform() : META.platform
    // 快手走iaa策略
    if (this.getUserAdChannel() == 200 || pf == "kuaishou_game"){
        return true
    }
    return false
}
UserManager.prototype.isIaaPassTopLevel = function () {
    cc.log("[iaa] isIaaPassTopLevel ",this.userLabel.iaaPassTopLevel)
    return this.userLabel.iaaPassTopLevel
}
UserManager.prototype.setIaaPassTopLevel = function () {
    this.userLabel.iaaPassTopLevel = true
}
UserManager.prototype.initUserLabel= function (src) {
    let self = this
    self.userLabel = src
    self.setRecentLevelPropConsume(self.userLabel.levelPropsConsumeList)
    UserTagData.getInstance().userLabelData = self.userLabel;
    let nowDay = Localhost.timeInDay()
    self.userLabel.loginNum30 = 0
    for (const key in self.userLabel.loginList) {
        let conf = self.userLabel.loginList[key]
        let loginDay = nowDay - conf
        if (loginDay > 0 && loginDay <= 30) {
            self.userLabel.loginNum30++
        }
    }
    // console.log("【掉落优化】 initUserLabel nowDay ",nowDay)
    if (self.userLabel.adSource){
        if (self.userLabel.adSource == 11){
            // 媒体投放传来的渠道号，用来标记用户来源
            _G.__CHANNEL_ID = "rongyao2307"
        }
        console.log("[ad] wechat _G.__CHANNEL_ID=" + tostring(_G.__CHANNEL_ID))
    }
}
UserManager.prototype.updateIsOpenNewLevel = function (flag) {
    this.isOpenNewLevel = flag
}
// 是否开启了新的关卡
UserManager.prototype.getIsOpenNewLevel = function () {
    return this.isOpenNewLevel
    // return true
}
// //关末广告ab测
// UserManager.prototype.initAdABTest = function () {
//     let self = this
//     self.addStepAdGroup = "a"
//     CubeOrthGroupHelper.getInstance().requestTestGroup(CubeExperimentConst["limitadsTest2"], function (data) {
//         // group = "g"
//         // data.group 
//         self.addStepAdGroup = data.group 
//     }, "a")
    
// }
//未满关打最高关
UserManager.prototype.playMaxLevelNotReachTopLevel = function (level) {
    if ( !this.reachTopLevel() && level == UserManager.getInstance().user.topLevelId){
        return true
    }
    return false 
}

// 是否第一次 当前最大关(包含神秘岛) 
UserManager.prototype.isFirstPassTopLevel = function (level) {
    // this.levelHighTryTimes
    // let num = isReplay ? 1 : 0
    let num = 0
    if (LevelType.isMysteryIslandLevel(level)){
        return this.topLevelPlayNum - num <= 1
    }
    //未满关打最高关
    if ( !this.reachTopLevel() && level == UserManager.getInstance().user.topLevelId){
        return this.topLevelPlayNum - num <= 1
    }
    
    return false
}
UserManager.prototype.addTopLevelPlayNum = function (level) {
    cc.log("passTopLv addTopLevelPlayNum ",level)
    if (LevelType.isMysteryIslandLevel(level) || ( !this.reachTopLevel() && level == UserManager.getInstance().user.topLevelId)){
        this.topLevelPlayNum++
        cc.log("passTopLv addTopLevelPlayNum this.topLevelPlayNum ",this.topLevelPlayNum)

    }
}
UserManager.prototype.cleanTopLevelPlayNum = function (level) {
    cc.log("passTopLv cleanTopLevelPlayNum ",level,UserManager.getInstance().user.topLevelId)
    level = level + 1
    const isMystery = LevelType.isMysteryIslandLevel(level);
    const topLevelId = UserManager.getInstance().user.topLevelId;
    if (isMystery || ( !this.reachTopLevel() && level == topLevelId) || (!isMystery && level > topLevelId)){
        this.topLevelPlayNum = 0
        cc.log("passTopLv cleanTopLevelPlayNum this.topLevelPlayNum ",this.topLevelPlayNum)
    }
}

//累计获得星星数
UserManager.prototype.setStarDrawStarNum = function (num) {
    let self = this
    // self.starDrawStarNum = self.starDrawStarNum || 0
    self.starDrawStarNum = num
    
}

//累计获得星星数
UserManager.prototype.getStarDrawStarNum = function () {
    let self = this
    return self.starDrawStarNum || 0
    
}

// 获取任意key
UserManager.prototype.getUserInfoByKey = function (key) {
    let self = this
    return self[key]
}

// 更新任意key
UserManager.prototype.updateUserInfoByKey = function (key, value) {
    let self = this
    self[key] = value
}

// 获取分组
UserManager.prototype.getAbTestByKey = function (key) {
    let self = this
    return self.abTestInfo[key] || "a"
}
// 获取当前关卡分组
UserManager.prototype.getLevelGroup = function () {
    let self = this
    return self.abTestInfo.levelGroup || "a"
}
UserManager.prototype.isLevelTestGroup = function () {
    return this.getLevelGroup() == "b"
}

// 是否能够领取过新手奖励
UserManager.prototype.getCanFetchBeginnerGift = function () {
    let self = this
    // console.log("[Novice] getCanFetchBeginnerGift="+self.canFetchBeginnerGift)
    return self.canFetchBeginnerGift
}
// 修改能够领取过新手奖励
UserManager.prototype.setCanFetchBeginnerGift = function (f) {
    let self = this
    return self.canFetchBeginnerGift = f
}
// 获取当前新手奖励分组
UserManager.prototype.getNoviceGiftGroup = function () {
    let self = this
    // console.log("[Novice] abTestInfo="+self.abTestInfo.beginnerGiftGroup)
    return self.abTestInfo.beginnerGiftGroup || "a"
}
// 更新月票信息
UserManager.prototype.updateMonthCardInfo = function (info) {
    let self = this
    self.monthCardInfo = info

}

UserManager.prototype.updateAdSkipExpireTs = function (adSkipExpireTs, type) {
    // let vagueTims = vague ? 30 * 60 * 1000 : 0
    this.adSkipExpireTs = adSkipExpireTs
    DCAssist.dc4AdSkipGiftBag("user_status", null, {
        num : Math.ceil(Math.max( adSkipExpireTs - Localhost.time(), 0) / (1000 * 60)),
        type : type ? type : (adSkipExpireTs ? "vip" : "none")
    })

}
// 是否有权益月票 vague 模糊比较 增加30分钟
UserManager.prototype.isHaveEquityMonthTicket = function (vague) {
    // let vagueTims = vague ? 30 * 60 * 1000 : 0
    return this.adSkipExpireTs > Localhost.time()
}
// 是否有资源月票
UserManager.prototype.isHaveResourceMonthTicket = function (vague) {
    let vagueTims = vague ? 30 * 60 * 1000 : 0
    return this.monthCardInfo.resourceEndTs + vagueTims > Localhost.time()
}
const MONTH_TICKET_NO_PROP_FIRST_TIP_KEY = "month_ticket_no_prop_tip_key_"
UserManager.prototype.isShowMonthTicketNoPropTip = function (){
    let uid = this.uid ? this.uid : ""
    let num = Localhost.getInstance().getDailyDataByKey(MONTH_TICKET_NO_PROP_FIRST_TIP_KEY+uid, 0)
    Localhost.getInstance().setDailyDataByKey(MONTH_TICKET_NO_PROP_FIRST_TIP_KEY+uid, num+1)
    cc.log("MonthTick isShowMonthTicketNoPropTip num ",num)
    return num <= 0
}
// 获取商品当日购买次数
UserManager.prototype.getGoodsDailyBuyNum = function (goodsId){
    let dailyData = this.getDailyData()
    return dailyData.buyedGoodsInfo[goodsId] || 0
}
// 是否显示关前道具引导
const PRE_PROPS_GUIDE_KEY = "pre_props_guide_key_"
UserManager.prototype.isShowPrePropsGuide = function (levelId){
    let showTime = cc.UserDefault.getInstance().getIntegerForKey(PRE_PROPS_GUIDE_KEY,0)
    let config = MetaManager.prePropsGuideConfig
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    if (this.getGroupByKey(config.ab_test_name) == "b" && MetaManager.prePropsGuideConfig.unlock_lv == topLevel
    && levelId == MetaManager.prePropsGuideConfig.unlock_lv){
        cc.UserDefault.getInstance().setIntegerForKey(PRE_PROPS_GUIDE_KEY,Localhost.time())
        return showTime == 0 
    }
}
// 最新取分组用法 方便后续实验名切换
UserManager.prototype.getGroupByModule = function (module,dGroup = "a") {
    let key = CubeOrthGroupHelper.getInstance().getCubeKeyByModule(module)
    console.log("[abTest] getGroupByModule ",module,key)
    return this.getGroupByKey(key,dGroup)
}
//getCubeGroupByKey
UserManager.prototype.getGroupByKey = function (key,dGroup = "a") {
    let self = this
    // console.log("[abTest] getGroupByKey key:",key)
    if (!self.abTestInfo.commonCubeGroup){
        return dGroup
    }
    console.log("[abTest] getGroupByKey key:"+key+" value:",self.abTestInfo.commonCubeGroup[key])
    return self.abTestInfo.commonCubeGroup[key] ? self.abTestInfo.commonCubeGroup[key] : dGroup
}
const SHOW_AD_DAY_FLAG_KEY = "show_ad_day_flag_key_";

//是否 开启月票 且 当日首次点击广告按钮
UserManager.prototype.isTodayFirstShowAd = function () {
    let self = this
    return new Promise((resolve, reject) => {
        let MonthTicketManager = require("../../activity/MonthTicket/MonthTicketManager").getInstance();
        if (MonthTicketManager.isOpen()) {
            if (UserManager.getInstance().user.topLevelId < MetaManager.getMonthTicketAdLevel()) {
                let today = String(Localhost.timeInDay());
                let day = cc.UserDefault.getInstance().getStringForKey(SHOW_AD_DAY_FLAG_KEY);
                if (today == day) {
                    console.log("权益卡:今日已强弹");
                    resolve(false);
                } else {
                    cc.UserDefault.getInstance().setStringForKey(SHOW_AD_DAY_FLAG_KEY, today);
                    console.log("权益卡:今日未强弹");
                    resolve(true);
                }
            } else {
                resolve(false);
            }
        } else {
            console.log("权益卡强弹月卡条件未满足");
            resolve(false);
        }
    })
}

UserManager.prototype.showTicketAd = function (successCb,failCb,adPos) { 
    require("../../activity/MonthTicket/MonthTicketManager").getInstance().showAdPanel(successCb,failCb,adPos);
}
/** 商城礼包AB测 */
UserManager.prototype.initNewShopCube = function () {
    let self = this;
    if(!self.newshop_package_test) {
        self.newshop_package_test = "a";
        CubeOrthGroupHelper.getInstance().requestTestGroup(CubeExperimentConst["newshop_package_test"], function (data) {
            self.newshop_package_test = data.group;
            console.log("商城礼包AB测 cube:" + self.newshop_package_test);
        }, "a")
    }
}

UserManager.prototype.getNewShopCube = function () {
    let self = this;
    return self.newshop_package_test || "a";
}


const TOP_LEVEL_FAIL_TIMES = "top_level_fail_times";
/** 获取关卡闯关失败次数*/
UserManager.prototype.getTopLevelFailTimesData = function(id) {
    let str = cc.UserDefault.getInstance().getStringForKey(TOP_LEVEL_FAIL_TIMES);
    if (str) {
        let temp = JSON.parse(str);
        if(temp.id == id) {
            return temp;
        }
    }
    return {id, count: 0, lastBuyTime: 0};
}

UserManager.prototype.setTopLevelFailTimes = function(id, count = 0) {
    let str = cc.UserDefault.getInstance().getStringForKey(TOP_LEVEL_FAIL_TIMES);
    let temp = {id, count, lastBuyTime: 0};

    if(str) {
       let data = JSON.parse(str);
        if(data.id == id) {
            temp.count = count;
            temp.lastBuyTime = data.lastBuyTime || 0;
        }
    }

    console.log("关末加步数策略优化: 重置数据", temp.id, temp.count, temp.lastBuyTime)
    cc.UserDefault.getInstance().setStringForKey(TOP_LEVEL_FAIL_TIMES, JSON.stringify(temp));
}

/** 购买加多次步数时调用 */
UserManager.prototype.buyTopLevelAddStep = function(id) {
    let str = cc.UserDefault.getInstance().getStringForKey(TOP_LEVEL_FAIL_TIMES);
    let temp = {id, count: 0,lastBuyTime: 0};
    if(str) {
       let data = JSON.parse(str);
        if(data.id == id) {
            temp = data;
            temp.lastBuyTime = data.count;
        }
    }
    console.log("关末加步数策略优化: 购买次数", temp.id, temp.count, temp.lastBuyTime)
    cc.UserDefault.getInstance().setStringForKey(TOP_LEVEL_FAIL_TIMES, JSON.stringify(temp));
}

UserManager.prototype.addTopLevelFailTimes = function(id, count = 1) {
    let str = cc.UserDefault.getInstance().getStringForKey(TOP_LEVEL_FAIL_TIMES);
    let temp = {id, count,lastBuyTime: 0};
    if(str) {
       let data = JSON.parse(str);
        if(data.id == id) {
            temp = data;
            temp.count = data.count + count;
        }
    }

    console.log("关末加步数策略优化: 添加失败次数", temp.id, temp.count, temp.lastBuyTime)
    cc.UserDefault.getInstance().setStringForKey(TOP_LEVEL_FAIL_TIMES, JSON.stringify(temp));
}

//加载关末优化步数用到的其他通用配置
UserManager.prototype.initTopLevelFailCfg = function() {
    let self = this;
    self.topLevelFailTimeCfg = {
        begin_top_level: 201,
        cost: 69,
    };
    //ab实验请求的关卡
    CfgManager.load("game").then(()=>{
        let config = CfgManager.get("game");
        if(config && config.begin_top_level) {
            self.topLevelFailTimeCfg.begin_top_level = config.begin_top_level;
        }
        CfgManager.release("game");
    })
    //购买加步数升级的价格
    CfgManager.load("wx_group_share").then(()=>{
        let config = CfgManager.get("wx_group_share");
        let str = config.addstep_buy_upgrade;
        if(str) {
            let arr = str.split(":");
            if(arr[1]) {
                self.topLevelFailTimeCfg.cost = Number(arr[1]);
            }
        }
        CfgManager.release("wx_group_share");
    })
}

UserManager.prototype.getTopLevelFailCfg = function() {
    if(!this.topLevelFailTimeCfg) {
        this.topLevelFailTimeCfg = {
            begin_top_level: 201,
            cost: 69,
        }
    }
    return this.topLevelFailTimeCfg;
}

const STICKER_TIP_KEY = "sticker_tip_key_";
// 是否有新的贴贴浏览提示
UserManager.prototype.isShowStickerTip = function() {
    let uid = this.uid || ""
    let str = cc.UserDefault.getInstance().getStringForKey(STICKER_TIP_KEY+uid,"")
    let remote = UserManager.getInstance().getSettingByKey("stickerBattleLastRecord", "")
    cc.log("StickerBattle isShowStickerTip ",str+"|"+remote)
    // 对比本地数据和远程数据相同说明不需要显示红点提示
    return str != remote
}
// 更新贴贴浏览记录（本地）
UserManager.prototype.updateStickerTipLocal = function() {
    let uid = this.uid || ""
    let remote = UserManager.getInstance().getSettingByKey("stickerBattleLastRecord", "")
    cc.UserDefault.getInstance().setStringForKey(STICKER_TIP_KEY+uid,remote)
}
// 更新贴贴浏览记录(远程)
UserManager.prototype.updateStickerTipRemote = function(value) {
    this.setSettingByKey("stickerBattleLastRecord",value)
}

//是否使用旧关末面板
UserManager.prototype.isUseOldRevivePanel = function() {
    let self = this;
    let cube = self.getGroupByKey(MetaManager.exitGameCube);
    return  cube == "a" /*|| !UserManager.getInstance().canIconShow("new_revive")*/;
}

//设置开局是否为无限精力
UserManager.prototype.setConsumeEnergy = function (consume) {
    let self = this;
    self.isConsumeEnergy = !!consume;
}

//获取开局是否为无限精力
UserManager.prototype.getConsumeEnergy = function () {
    let self = this;
    return self.isConsumeEnergy;
}

//是否支持勋章功能
UserManager.prototype.supportMedal = function() {
    let self = this;
    //qq小游戏上玩的玩吧用户不显示勋章功能。因为后端不会给发改类型玩家发放勋章，不会上榜。
    if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame && META.specialPFInQQlightgame == "wanba_ts") {
        return false;
    }
    return self.canIconShow(addPfSuffix("medal_rank"));
}

// 关前关末banner - 好友排行榜功能类型
UserManager.prototype.getFriendRankType = function() {
    let friendType = 0;
    if (!global.mini || mini.supportOpenContext()) {
        //  创建好友排行榜，可能存在没有开放域但有分享，存在游戏好友的情况，所以开放域排行榜和非开放域排行榜都写了，将来有修改直接改判断条件即可
        if (global.mini && mini.supportOpenContext()) {
            friendType = 1;
        } else {
            friendType = 2;
        }
    }
    return friendType;
}
UserManager.prototype.getPayConfigHW = function() {
    // return{
    //     applicationID: "106938495",
    //     publicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAptMHFafAM9+dNgGbup1pCCBwK5VqOiFjYUFQDZuL6r2wx1qWYw737MILEypVBufGZObIuvqLsiHbOiOAC/vLwyvK+C2B1KcGizsRAEGmArIujK58uKSdaCxrn277dTwHaKmMyjRt0X0Nr2iIJzHg1A0+WK0EUZPn+HvR+gusDhYx/pjH50ryUDcL0e1I/b6OgIjLIl4yIarhWFQa4L5rcf3AqYkyYpiFWFx2djSjzY4WgI41KKDG2gEqEoOOlQwnakRCsTh4KZpXC2NsDBpRLnEBfiOuF2r2SAqclW4tKxFWApa3xiHtp5BQD4wV2HvvELrhUG1DhF0hnnBJbJf1yQIDAQAB"
    // }
    return{
        applicationID: "106938495",
        publicKey: "MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEAxGqB+RE85ILd7RiRe7pJTnztvThawJXmoroJOxlzsw+YkDvmrrTo3637wMh6om6h8TSRFpYKdrM20rFRr6QE/tRRX+ztJV6FmkJnt75+p+TpvfbPrSx7LP3BiAcqsIV/QPXi9/oMdNYKHV6j3DlwZgA0FsgWyiHTPqK8yAkG6DPf/c0c2M80mRIsSXjHqK3CYnr8JgIXocmyZaacglgSBGeZ340OBzdmAXwfiXoef0n7GbBUARqARroKoJ9HvRTf+8VdkNQEzoTcnis6MJ+1dpSXntfcNdsU9zSM0/TwhnPkCGVKLKX468Es4QDXDS42OtPJ7njsYPX49GH7vInSkxCLyo32HxRZUHhTdLN0nUG/xboesNWazsOEL/lifUbtIrYr4l7CuW7PIZYegVj8GP9vTcHJ01HqQRyjhtU8XkycbkmABorEw/DTFdSdyuuE4GJm1e7Sb3OrB8p/UQTd0ccAefLn92Bdu9CCmlZYUdVlpNfH9P9A7awfyfpHLcOjAgMBAAE="
    }
}
UserManager.prototype.isFullStar = function() {
    let self = this
    let totalStar = self.getUserRef().getTotalStar()
    let allStars = LevelConfigManager.getInstance().getTotalStars()
    cc.log("isFullStar totalStar ",totalStar,allStars)
    return totalStar >= allStars
}

UserManager.prototype.setTTSmallAmountUseDiamond = function(value){
    this.ttSmallAmountUseDiamond = value
}

UserManager.prototype.getTTSmallAmountUseDiamond = function(){
    return this.ttSmallAmountUseDiamond
}

UserManager.prototype.setTTRevisistReward = function(value){
    this.ttRevivistReward = value
    cc.UserDefault.getInstance().setIntegerForKey("tt_revisit_reward", 1)
}

UserManager.prototype.getTTRevisistReward = function(){
    return this.ttRevivistReward
}

//重置活动连胜次数
UserManager.prototype.resetActivityStreakBuff = function (levelId) {
    const topLevelId = UserManager.getInstance().user.topLevelId;
    const isMystery = LevelType.isMysteryIslandLevel(levelId);
    if (topLevelId == levelId || isMystery) {
        console.log("重置活动连胜次数")
        FishingManager.getInstance().info.winningStreak = 0;
        StickerBattleManager.getInstance().getData().setWinningStreak(0);
        CircusGameData.getInstance().setContinueWin(0)
        DunkAceData.getInstance().setComboLevelNum(1);
    }
}

/**
 * 定义：连续流失14个自然日及以上的用户
 * 回流用户标签持续时间：回流当日起7个自然日（回流当日计算为第一日）
 * @param {*} duration 回流状态持续天数，默认为7天
 * @returns 是否是回流用户
 */
UserManager.prototype.isReturnBack = function (duration = 7) {
    let self = this;
    let loginList = self.userLabel.loginList;
    let isRecall = false;
    const nowDay = Localhost.timeInDay();
    if (loginList && loginList[1]) {
        //
        for (let i = 1; i < loginList.length - 1; i++) {
            const last = loginList[i + 1];
            if (last - loginList[i] > 14 && nowDay - last < duration) {
                isRecall = true;
                break;
            }
        }
    }
    console.log("回流用户: ", duration, isRecall);
    return isRecall;
}

/**
 * 今日注册的用户，作为新增用户
 * @param {*} duration 状态持续天数，默认为3天
 * @returns 是否是 新增用户
 */
UserManager.prototype.isNewUser = function (duration = 3) {
    let self = this;
    const nowDay = Localhost.timeInDay();
    const createDay = Localhost.timeInDay(self.createTime / 1000);
    const isNew = nowDay - createDay < duration;
    console.log("新增用户：", duration, isNew, nowDay, createDay);
    return isNew;
}

/**
 * 获取每日付费记录
 */
UserManager.prototype.getPayRecord = function () {
    let self = this;
    if (!self.recentPay) {
        self.recentPay = self.userLabel.recentPay;
    }
    console.log("付费金额：", self.recentPay);
    return self.recentPay;
}

/** 添加付费记录 */
UserManager.prototype.addPayRecord = function (money) {
    let self = this
    if (!self.recentPay) {
        self.recentPay = self.userLabel.recentPay;
    }
    const nowDay = Localhost.timeInDay();
    if (!self.recentPay[nowDay]) {
        self.recentPay[nowDay] = money;
    } else {
        self.recentPay[nowDay] += money;
    }
    console.log("更新付费金额：", self.recentPay);
}

UserManager.prototype.hasGotStar = function (levelId, starNum) {
    let self = this
    if (starNum === null) {
        starNum = 1
    }
    let score = self.getUserScore(levelId)
    if (score !== null && score.star !== null && score.star >= starNum) {
        return true
    }
    return false
}
//后端数据覆盖前端
UserManager.prototype.setRecentLevelPropConsume = function (value) {
    let self = this
    self.levelPropsConsumeList = (type(value) === "table") && value || table()
    cc.log("[NuclearBird] setRecentLevelPropConsume",self.levelPropsConsumeList)
}
UserManager.prototype.getRecentLevelPropConsume = function () {
    let self = this
    return self.levelPropsConsumeList || table()
}
//前端维护 
UserManager.prototype.addLevelConsumeProp = function (value) {
    let self = this
    if (!self.levelPropsConsumeList[1]) {
        self.levelPropsConsumeList[1] = 0
    }
    self.levelPropsConsumeList[1] = self.levelPropsConsumeList[1] + tonumber(value)
    cc.log("[NuclearBird] addLevelConsumeProp",self.levelPropsConsumeList)
}
UserManager.prototype.tryAddNewLevelConsumeRecord = function (levelId) {
    let self = this
    let tmpValueList = table.clone(self.levelPropsConsumeList)
    self.levelPropsConsumeList[1] = 0
    let curLen = 2
    for (let k in tmpValueList) {
        let v = tmpValueList[k]
        if ($null(v)) continue
        self.levelPropsConsumeList[curLen] = v
        curLen = curLen + 1
        if (curLen > 100) {
            break
        }
    }
    cc.log("[NuclearBird] tryAddNewLevelConsumeRecord",self.levelPropsConsumeList)
}
UserManager.prototype.updateLevelConsumeLocal = function (levelId, itemList) {
    let self = this
    //只检查主线关和神秘岛
    if (LevelType.isMainLevel(levelId) || LevelType.isMysteryIslandLevel(levelId)) {
        //刷旧关不算消耗
        if (self.hasGotStar(levelId, 1)) {
            return 
        }
        // let userExtendRef = self.getUserExtendRef()
        let metaMgr = MetaManager.getInstance()
        for (let k in itemList) {
            let itemId = itemList[k]
            if ($null(itemId)) continue
            let value = metaMgr.getPropConsumeValue(itemId)
            // QAGUILogger.getInstance().print("[NuclearBird] addpropuse itemId=" + tostring(itemId) + " value=" + tostring(value), "nuclearbird")
            if (value > 0) {
                self.addLevelConsumeProp(value)
            }
        }
    }
}
UserManager.prototype.getLevelConsume = function (levelCount) {
    let self = this
    // return 0
    let rencentConsumeList = self.getRecentLevelPropConsume()
    let value = 0
    for (let i = 1; i <= levelCount; i += 1) {
        if (rencentConsumeList[i]) {
            value = value + tonumber(rencentConsumeList[i])
        }
    }
    value = value / levelCount
    cc.log("掉落 getLevelConsume ",levelCount,value,rencentConsumeList)
    QAGUILogger.getInstance().print("[NuclearBird]list=" + table.tostring(rencentConsumeList), "nuclearbird")
    return value
}
// 是否在审核中（仅表示审核状态，具体逻辑单独处理）
UserManager.prototype.isInReview = function () {
    return this.inReview 
}

//点击打开个人信息面板
UserManager.prototype.openNameCradPanel = function(targetUid, params, cb) {
    const NamecardPanel = require("../panel/nameCard/NamecardPanel");
    if(NamecardPanel.isShow) {
        cb && cb();
        return;
    }
    //
    let onSuccess = function (evt) {
        if (evt && evt.data) {
            const data = evt.data;

            let userShow = UserManager.getInstance().getUserShowRef()
            userShow.setNameEffectList( $tableToArray(data.nameEffectDressList))

            data.params = params;
            NamecardPanel.show(data, cb);
        } else {
            cb && cb();
        }
    }

    let onFail = function (evt) {
        Toast.make(curryQuickGetErrorText(evt.data));
        cb && cb();
    }

    let http = UserProfileShowHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load(targetUid);
}

//是否将星星幸运礼移到福利中心
UserManager.prototype.isHideStarDrawIcon = function() {
    return UserManager.getInstance().getGroupByModule("star_draw_icon") == "b";
}
